import { useSelector } from 'react-redux';

export function getIsAuthenticated(state) {
  return Boolean(state?.auth?.isAuthenticated);
}

export default function useIsAuthenticated() {
  return useSelector(getIsAuthenticated);
}
